/* bb-cart-promo.js — Aktion des Monats im Warenkorb (v3, mit Stufen) */
if (!customElements.get('bb-cart-promo')) {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let busy = false;
  let lastActions = '';

  const post = async (path, body) => {
    const res = await fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || res.status);
    return data;
  };

  const refreshCart = () => {
    const items = document.getElementById('cart-items');
    if (items && typeof items.refresh === 'function') {
      items.refresh();
    } else {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
    }
  };

  class BBCartPromo extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick);
      this.initSlider();
      this.applyFixes();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    initSlider() {
      const track = this.querySelector('.bb-promo__track');
      const navs = this.querySelectorAll('.bb-promo__nav');
      if (!track || navs.length < 2 || this.querySelector('.bb-promo__slider--grid')) return;
      const [prev, next] = navs;
      const selected = track.querySelector('.is-selected');
      let placed = false;

      const update = () => {
        if (!placed && track.clientWidth > 0) {
          if (selected) track.scrollLeft = selected.offsetLeft;
          placed = true;
        }
        const overflow = track.scrollWidth > track.clientWidth + 2;
        prev.hidden = !overflow;
        next.hidden = !overflow;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };

      navs.forEach((btn) => {
        btn.addEventListener('click', () => {
          track.scrollBy({ left: Number(btn.dataset.dir) * track.clientWidth, behavior: 'smooth' });
        });
      });
      track.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(track);
      }
      update();
    }

    async applyFixes() {
      const raw = this.dataset.actions || '';
      if (!raw || busy || raw === lastActions) return;
      lastActions = raw;
      const actions = raw.split(';').filter(Boolean).map((entry) => {
        const i = entry.lastIndexOf(':');
        return { id: entry.slice(0, i), quantity: Number(entry.slice(i + 1)) };
      });
      busy = true;
      try {
        for (const action of actions) await post('cart/change.js', action);
      } catch (e) {
        console.warn('Aktion des Monats:', e);
      }
      busy = false;
      refreshCart();
    }

    async handleClick(evt) {
      const btn = evt.target.closest('button[data-variant-id]');
      if (!btn || btn.disabled || busy) return;
      busy = true;
      this.classList.add('is-loading');
      try {
        // Erst das neue Geschenk hinzufügen ...
        await post('cart/add.js', {
          items: [{ id: Number(btn.dataset.variantId), quantity: 1, properties: { _bb_aktion: 'gratis' } }]
        });
        // ... und nur beim Tauschen danach das alte entfernen
        if (btn.hasAttribute('data-swap') && this.dataset.currentKey) {
          await post('cart/change.js', { id: this.dataset.currentKey, quantity: 0 });
        }
      } catch (e) {
        console.warn('Aktion des Monats:', e);
      }
      busy = false;
      lastActions = '';
      refreshCart();
    }
  }

  customElements.define('bb-cart-promo', BBCartPromo);
}